import React from 'react'
import Navbar from '../navbar/Navbar'
import Footer from '../footer/Footer'

export default function PageWrapper({ children }) {
    return (
        <>
            <Navbar />
            <main className='page-content'>
                { children }
            </main>
            <Footer />
        </>
    )
}
